<template>
  <div>
    <MapModal
      :modalNode="modalNode"
      :close="cancel"
      :title="routeInteractionTitle"
      id="stationInformation"
    >
      <template slot="content">
        <!-- <schemeDesignLine
        ref="schemeDesignLine"
        @getPlanGuid="getPlanGuid($event)"
        @getDesignLineGuid="getDesignLineGuid($event)"
      ></schemeDesignLine> -->
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-width="80px"
          class="settings"
        >
          <el-form-item label="查询方法" prop="resource">
            <el-radio-group v-model="form.resource">
              <el-radio label="1" style="margin-bottom: 0;">定点</el-radio>
              <el-radio v-if="0" label="2" style="margin-bottom: 0;"
                >输入</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="路线"
            prop="scheme"
            class="is-required"
            v-if="schemeOptions.length > 1 && form.resource == 2"
          >
            <el-select v-model="form.scheme" placeholder="请选择路线">
              <span
                v-for="(item, index) in schemeOptions"
                :class="index == 0 ? 'hidden-options' : ''"
              >
                <el-option
                  class="selectStyle"
                  :label="item.name"
                  :value="item.guid"
                  :key="item.guid"
                ></el-option>
              </span>
            </el-select>
          </el-form-item>
          <el-form-item
            label="查询桩号"
            class="is-required"
            prop="stake"
            v-if="form.resource == 2"
          >
            <el-input
              v-model="form.stake"
              placeholder="请输入桩号（ k***+*** ）"
            ></el-input> </el-form-item
        ></el-form>
        <div class="positioning" v-if="form.resource == 1">
          <span>定位</span>
          <el-button type="primary" @click="pickPoint">地图选点</el-button>
        </div>
      </template>
      <template slot="foot">
        <div class="foot-operate">
          <el-button type="primary" @click="cancel" v-if="form.resource == 1">
            取消
          </el-button>
          <el-button type="primary" :disabled="submitting" @click="onSubmit">
            {{ submitting ? "查询中" : "查询" }}
          </el-button>
        </div>
      </template>
    </MapModal>
    <MapModal
      v-if="tableShow"
      :modalNode="modalNode2"
      :close="tableClose"
      title="查询结果"
    >
      <template slot="content">
        <el-table
          :data="tableData"
          style="width: 100%; padding: 0 20px;"
          @row-click="rowClick"
        >
          <el-table-column prop="lot" label="段落"> </el-table-column>
          <el-table-column prop="stake" label="桩号"> </el-table-column>
        </el-table>
      </template>
    </MapModal>
  </div>
</template>
<script>
const MapModal = () => import("@/components/common/mapModal/Index");
const schemeDesignLine = () => import("./schemeDesignLine.vue");

import {
  getStakeByBLH,
  getPointService,
  getPlansService,
  getLocationInformationByStake,
  getLocationInformationsByStake,
  getQueryStake,
} from "@/api/api";
import * as mapWork from "./map.js";

export default {
  name: "stationInformation",
  components: { MapModal, schemeDesignLine },
  props: ["close"],
  data() {
    return {
      routeInteractionTitle: "桩号信息",
      modalNode: {
        stationInformation: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 106,
            y: -376,
          },
          height: "auto", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
      modalNode2: {
        stationInformationTable: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 380,
            y: -376,
          },
          height: "400px", // 配置模态框中心高度
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
      projectId: window.sessionStorage.getItem("nowProjectId"),
      position: [], //选点
      planGuid: null,
      designLineGuid: null,
      form: {
        resource: "1",
        scheme: null,
        stake: null,
      },
      schemeOptions: [],
      rules: {
        scheme: [{ required: true, message: "请选择路线", trigger: "change" }],
        stake: [{ required: true, message: "请输入桩号", trigger: "change" }],
      },
      submitting: false,
      tableData: [],
      tableShow: false,
    };
  },
  methods: {
    rowClick(e) {
      this.getLocationInformationByStakeFn(
        this.form.scheme,
        e.stake,
        e.designLineGuid
      );
    },
    tableClose() {
      this.tableShow = false;
      this.tableData = [];
      mapWork.clearLayer();
      mapWork.createLayer();
    },
    cancel() {
      mapWork.clearLayer();
      this.close();
    },
    getPlanGuid(data) {
      this.planGuid = data;
    },
    getDesignLineGuid(data) {
      this.designLineGuid = data;
    },
    // 地图选点
    pickPoint() {
      this.tableShow = false;
      this.tableData = [];
      mapWork.clearLayer();
      mapWork.createLayer();
      this.position = [];
      if (mapWork.graphicDotsine) mapWork.graphicDotsine.clear();
      mapWork.createGraphic();
      mapWork.graphicDotsine.on(mars3d.EventType.drawCreated, (e) => {
        let { _alt, _lat, _lng } = mars3d.LngLatPoint.fromCartesian(
          e.graphic._position_draw
        );
        this.position = [_lng, _lat, _alt];
      });
    },
    getPlansMethod() {
      getPlansService({
        // projectGuid: "5b9f36bf-05a7-11ee-915e-00505688b0dd",
        projectGuid: window.sessionStorage.getItem("roadProjectId"),
      }).then((res) => {
        // console.log("getPlansService", res.data.data);
        let schemeOptions = [];
        res.data.data.forEach((item) => {
          // if (item.type == 2) {
          schemeOptions.push(item);
          // }
        });
        this.schemeOptions = schemeOptions;

        this.$nextTick(() => {
          if (this.schemeOptions.length > 0) {
            this.form.scheme = this.schemeOptions[0].guid;
            // this.$emit("getPlanGuid", this.form.scheme);
            // this.getDesignLinesMethod(this.form.scheme);
          }
        });
      });
    },
    // 确定
    onSubmit() {
      // if (!this.$refs.schemeDesignLine.requiredCheck("form")) return;
      if (this.form.resource == 1) {
        if (this.position.length === 0) {
          return this.$notify({
            title: "请进行地图选点",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
        }
        this.submitting = true;
        getStakeByBLH({
          planGuid: this.schemeOptions[0].guid,
          l: this.position[0],
          b: this.position[1],
          h: this.position[2],
        }).then((res) => {
          this.submitting = false;
          if (res.data.statusCode !== 500) {
            const {
              distance,
              elevation,
              slope,
              stake1,
              x,
              y,
              z,
              designLineGuid,
            } = res.data.data;
            mapWork.selectPoint.setStyle({
              label: {
                text: `偏距: ${distance}\nX: ${x}\nY: ${y}\nZ: ${z}`,
                outline: true,
                outlineColor: "#000",
                outlineWidth: 4,
              },
            });
            this.getLocationInformationByStakeFn(
              this.schemeOptions[0].guid,
              stake1,
              designLineGuid,
              false
            );
          } else {
            this.position = [];
            if (mapWork.graphicDotsine) mapWork.graphicDotsine.clear();
            this.$notify({
              title: res.data.errors,
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
          }
          // this.submitting = false;
        });
      } else {
        if (mapWork.graphicDotsine) {
          mapWork.graphicDotsine.stopDraw();
          mapWork.graphicDotsine.clear();
        }

        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.submitting = true;
            this.getLocationInformationsByStakeFn(
              this.form.scheme,
              this.form.stake
            );
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      }
    },
    getLocationInformationByStakeFn(
      planGuid,
      stake,
      designLineGuid = null,
      isFlyTo = true
    ) {
      getLocationInformationByStake({
        planGuid,
        stake,
        designLineGuid,
      })
        .then((res2) => {
          if (res2.data.statusCode == 200 || res2.data.statusCode == 204) {
            const {
              l,
              b,
              h,
              slope,
              elevation,
              kHStake,
              brokenStake,
            } = res2.data.data;

            getQueryStake({
              designLineGuid,
              stake: brokenStake,
            }).then((item) => {
              // console.log("getQueryStake", item.data.data);
              let buildTender = item.data.data
                ? item.data.data.buildTender
                : "";
              mapWork.createStakeGraphic(
                stake,
                slope,
                elevation,
                [l, b, h],
                buildTender
              );
            });

            this.showHectometerStake(kHStake, isFlyTo);
          } else {
            this.$notify({
              title: res2.data.errors,
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
          }
          this.submitting = false;
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            title: "获取失败",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
          this.submitting = false;
        });
    },
    getLocationInformationsByStakeFn(planGuid, stake) {
      getLocationInformationsByStake({
        planGuid,
        stake,
      })
        .then((res) => {
          this.submitting = false;
          if (res.data.statusCode != 200) {
            this.$notify({
              title: res.data.errors,
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
            return false;
          }
          if (res.data.data.length > 1) {
            let data = res.data.data;
            let lot = [];
            data.forEach((item) => {
              lot.push(this.getLot(item));
            });
            const allPromise = Promise.all(lot);
            allPromise.then((values) => {
              this.tableData = data;
              this.tableShow = true;
            });
          } else {
            this.tableShow = false;
            this.getLocationInformationByStakeFn(
              this.form.scheme,
              res.data.data[0].stake,
              res.data.data[0].designLineGuid
            );
          }
        })
        .catch((error) => {
          this.submitting = false;
          console.log(error);
        });
    },
    showHectometerStake(arr, isFlyTo = true) {
      let newArr = [];
      console.log("showHectometerStake", arr);
      arr.forEach((item) => {
        newArr.push({
          position: [item.l, item.b, item.h],
          text: item.stake,
          type: item.type,
        });
      });
      mapWork.drawDots(newArr, isFlyTo);
    },

    // 获取标段
    getLot(item) {
      return new Promise((resolve) => {
        console.log(item);
        getQueryStake({
          designLineGuid: item.designLineGuid,
          stake: item.brokenStake,
        }).then((data) => {
          item.lot = data.data.data ? data.data.data.buildTender : "";
          resolve(data.data.data ? data.data.data.buildTender : "");
        });
      });
    },
  },

  mounted() {
    this.getPlansMethod();
  },
  destroyed() {
    this.tableShow = false;
    this.tableData = [];
    mapWork.clearLayer();
    mapWork.createLayer();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/index.scss";
@import "@/assets/scss/box.scss";
.foot-operate {
  padding: 10px 10px;
  border-top: 1px solid rgba(245, 245, 245, 0.6) !important;
  justify-content: flex-end;
  align-items: center;
  display: flex;
  /deep/ .el-button {
    margin: 0 5px;
    font-size: 12px;
    padding: 3px 10px;
    line-height: inherit;
    height: auto;
  }
}
.positioning {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -20px;
  padding-bottom: 20px;
  margin-bottom: 20px;
  font-size: 12px;
  color: #fff;
  span {
    padding-right: 0px;
    padding-left: 7px;
  }
  /deep/ .el-button {
    margin-right: 100px;
    margin-left: 11px;
    font-size: 12px;
    padding: 3px 10px;
    line-height: inherit;
    height: auto;
    border-color: rgba(42, 183, 255, 0.66) !important;
    background-color: rgba(42, 183, 255, 0.66) !important;
  }
}

.el-form.settings {
  width: 100%;
  padding: 8px 36px 17px 0;
  /deep/ .el-radio-group {
    margin-top: 7px !important;
  }
  /deep/ .el-form-item {
    width: 100%;
    padding: 0 0 0 18px;
    margin: 20px 0px;
    margin-top: 0;

    .el-form-item__label {
      min-height: 1px;
      margin-bottom: 0px;
      font-size: 12px;
      @include font_color("t_color_op1");
      padding-right: 10px;
      line-height: 32px;
    }
    .el-form-item__content {
      margin-left: 0px !important;
      font-size: 12px;
      display: flex;
      align-items: center;
      flex-grow: 1;
      line-height: 32px;
      min-height: 32px;
      .el-select {
        @include select_base();
        width: 100%;
      }
      .el-input {
        @include input_base();
      }
      .el-textarea {
        @include textarea_base();
      }
      .el-checkbox {
        @include checkbox_base();
      }
    }
    .el-input__inner {
      width: 100% !important;
    }
    .el-input-group__prepend {
      border-color: rgba(245, 245, 245, 0.6) !important;
      color: rgba(255, 255, 255, 0.9) !important;
      background: none;
      padding: 0 10px;
    }
    &.btns {
      padding: 6px 0 0 89px;
      .el-form-item__content {
        width: auto;
        .el-button--primary {
          @include lheight(28);
          @include font_color("t_color_op1");
          @include background_color("t_color1_op2");
          @include border_color("t_color1_op2");
          padding: 0 15px;
          margin: 6px 16px 0 0;
          span {
            @include lheight(28);
            font-size: 12px;
            display: block;
            text-align: center;
          }
          &:hover {
            @include background_color("t_color1_op1");
            @include border_color("t_color1_op1");
          }
          &.is-disabled {
            // @include font_color("t_color_sc1");
            // @include background_color("t_color1_op3");
            @include border_color("t_color1_op3");
            background-color: rgba(42, 183, 255, 0.4) !important;
            color: rgba(255, 255, 255, 0.9) !important;
            &:hover {
              background-color: rgba(42, 183, 255, 0.4) !important;
            }
            span {
              background: none;
              // @include font_color("t_color_sc1");
            }
          }
        }
        .el-button--default {
          @include lheight(28);
          @include font_color("t_color_op2");
          @include background_color("t_color3_op2");
          @include border_color("t_color_op2");
          padding: 0 15px;
          margin: 6px 16px 0 6px;
          span {
            @include lheight(24);
            font-size: 12px;
            display: block;
            text-align: center;
          }
          &:hover {
            @include background_color("t_color3_op1");
            @include border_color("t_color_op1");
            @include font_color("t_color_op1");
          }
        }
      }
    }
    &:first-child {
      padding: 10px 0 0 18px;
    }
    &.is-error {
      .el-form-item__content .el-input input.el-input__inner {
        border-color: #f56c6c !important;
      }
    }
  }
  .main .el-form-item.btns {
    // padding: 0;
    // margin: 0;
    .el-form-item__content .el-button--primary {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 12px 20px;
    }
  }
  .rich {
    /deep/ .el-form-item__label {
      float: none;
    }
    /deep/ .el-form-item__content {
      width: 100% !important;
      margin: 0 !important;
    }
  }
}

.flexRight {
  display: flex;
  padding: 20px 0px;
  margin-right: -16px;
  align-items: center !important;
  width: 100%;
  justify-content: flex-end;
}

#stationInformation {
  /deep/.el-form {
    label {
      margin-bottom: 0;
    }
  }
  .is-error {
  }
}

/deep/ .el-table {
  background-color: transparent;
  th,
  tr,
  td {
    background-color: transparent;
    padding: 6px 0;
    text-align: center;
    font-size: 12px;
  }
  tr,
  td {
    cursor: pointer;
  }
  .cell {
    color: rgba(255, 255, 255, 0.9);
  }
  th {
    .cell {
      padding: 2px 0;
      color: rgba(0, 255, 255, 0.9) !important;
    }
  }

  th.is-leaf {
    border-bottom-color: rgba(245, 245, 245, 0.6) !important;
  }
  &::before {
    display: none;
  }
}
/deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: rgba(238, 247, 255, 0.12) !important;
}
.hidden-options {
  display: none;
}
</style>
